<div class="d-flex proposal-details-row outer-container">
  <ng-container *ngIf="attachedFiles?.length > 0; else noUpload">
    <div class="download-wrapper w-100">
      <ng-container *ngFor="let binaryData of attachedFiles">
        <div class="d-flex flex-row upload-container">
          <div class="d-flex align-items-center justify-content-center">

            <span class="upload-icon-background"><img class="upload-icon"
                                                      [src]="fileUploadService.getIconSourceForFilename(binaryData.name)"
                                                      alt=""></span>

          </div>

          <div class="upload-file-text">
            <span> {{binaryData.name}}</span> <br>
            <div *ngIf="inBillBoard" class="d-flex justify-content-start upload-file-subtext">
              {{binaryData.sizeInBytes | formatFileSize}} - {{binaryData.createDate| date : ('dateFormat' | translate)}}
            </div>
            <div *ngIf="!inBillBoard" class="d-flex justify-content-start upload-file-subtext">
              {{binaryData.sizeInBytes | formatFileSize}}
            </div>
          </div>
          <button *ngIf="!loadingStatus.get(binaryData.id)" class="download-button"
                  (click)="downloadFile(binaryData)">
            <mat-icon>file_download</mat-icon>
          </button>
          <button *ngIf="(binaryData.uploadLocation === UploadLocation.BILLBOARDGENERAL ||
                          binaryData.uploadLocation === UploadLocation.BILLBOARDGENERALMEETINGS ||
                          binaryData.uploadLocation === UploadLocation.BILLBOARDAUTHORISATIONS ||
                          binaryData.uploadLocation === UploadLocation.BILLBOARDAPPLICATIONS )
                          && (roles$|async).includes(Roles.ROLE_ASSOCIATION_ADMIN)" class="download-button"
                  (click)="deleteFile(binaryData)">
            <mat-icon>delete</mat-icon>
          </button>
          <div *ngIf="loadingStatus.get(binaryData.id)" class="spinner-container">
            <mat-spinner diameter="24"></mat-spinner>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-template #noUpload>
    <div class="d-flex noUpload">
      {{'proposalDetails.noUploads' | translate}}
    </div>
  </ng-template>
</div>



